export default __webpack_public_path__ + "i18n/translations/translation-mr.36590626.json";